import clsx from 'clsx'
import './Loading.scss'

interface ILoading {
    isLoading?: boolean
    className?: string
}

function Loading({ isLoading, className }: ILoading) {
    return (
        <>
            {isLoading && (
                <div className={clsx(className, 'reusable-spinner')}>
                    <div className="rect1 mr-1 main-bg" />
                    <div className="rect2 mr-1 bg-dark-shade-blue" />
                    <div className="rect3 mr-1 main-bg" />
                    <div className="rect4 mr-1 bg-dark-shade-blue" />
                    <div className="rect5 mr-1 main-bg" />
                </div>
            )}
        </>
    )
}

export default Loading
